import { Component, OnInit, Optional, Inject } from '@angular/core';
import { ModPreloginService } from '../../services/modprelogin-service.service';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'mod-update',
    templateUrl: './market-update.component.html',
    styleUrls: ['./market-update.component.css']
})
export class MarketUpdateComponent implements OnInit {

    public response: any;
    public imageUrl: String;
    public header: string = '';
    public enablePreLoginModContent: boolean = true;

    constructor(private translationService: PershingTranslationService, private modPreloginService: ModPreloginService,
                @Optional() @Inject('AppSettings') private appSettings: any) {
        this.header = 'MARKET_UPDATE';
        this.translationService.addTranslationFolder('@pershing/nxi-ng-mod', 'node_modules/@pershing/nxi-ng-mod/lib');
    }

    ngOnInit() {
        if ((!this.appSettings.ibdConfigMap.enablePreLoginModContent) ||
            (this.appSettings.language === 'es' && this.appSettings.ibdConfigMap.disableSpanishPreLoginModContent)) {
            this.enablePreLoginModContent = false;
        }
        // this image is available only inside the generic site.
        this.imageUrl = this.appSettings.ibdConfigMap.cdnURL + '/pershing.netxinvestor.brands/' + this.appSettings.ibdConfigMap.brands_version + '/themes/' +
                       this.appSettings.ibdConfigMap.themeName + '/images/' + 'argus_logo.png';
        this.getModResponse();
    }

    getModResponse() {
        this.response = this.modPreloginService.getModPreloginComponentRespose(this.appSettings.ibdConfigMap.modApiUrl, 'welcomemarketupdate');
    }
}
